export default __webpack_public_path__ + "static/media/image.f030318e.png";